import { styled } from '../../styled-components';

export const UiWhiteSpaceNoWrap = styled.div.attrs({
  className: 'UiWhiteSpaceNoWrap',
})`
  white-space: nowrap;
`;
